export const ROW_TITLE_COUNTRY = 'Built in';
export const ROW_TITLE_DISTRIBUTOR = 'Distributor';
export const ROW_TITLE_PREDECESSOR = 'Predecessor';
export const ROW_TITLE_RATING = 'Rating';
export const ITEM_TITLE_FB_MESSAGE = 'Message on Facebook';
export const TEXT_PILL_BUTTON_BOOK_TEST_DRIVE = 'Book test drive';
export const TEXT_PILL_BUTTON_GET_TRADE_IN_OFFER = 'Get trade-in offer';
export const TEXT_PILL_BUTTON_PRICELIST = 'Pricelist';
export const TEXT_PILL_BUTTON_BROCHURE = 'Brochure';

export const ICON_SIZE_IN_PIXEL = 16;
export const LIST_TYPE_LABEL_SIZE = 10;
export const COLOR_GRAY_1 = 'gray-1';
export const STAR_RATING_ICON_SIZE_DEFAULT = 14;
